module.exports = __webpack_public_path__ + "static/media/cyber-corn-explosion-2.2d579f75.jpg";